import { getIsAgentActive } from './getIsAgentActive.js';
import { getPatientChatState } from './getPatientChatState.js';
/**
 * Determines whether the patient can send a free message in the chat.
 * Requires: patient status is ACTIVE and no agent is currently running.
 *
 * @__NO_SIDE_EFFECTS__
 */
export function getPatientCanSendMessage(events) {
    const state = getPatientChatState(events);
    if (state.status !== 'ACTIVE') {
        return false;
    }
    return !getIsAgentActive(events);
}
//# sourceMappingURL=getPatientCanSendMessage.js.map